import React from 'react'
import Iconfont from '../iconfont/iconfont'
import { Tooltip } from 'antd'

interface TipProps {
    text: string
    theme?: 'dark' | 'blank'
    size?: number
    styles?: React.CSSProperties
}

const Tip: React.FC<TipProps> = props => {
    return (
        <Tooltip
            arrowPointAtCenter
            overlayClassName={props.theme === 'blank' ? 'custom-popover' : void 0}
            placement="topLeft"
            title={props.text}
        >
            <div data-cursor-pointer style={props.styles}>
                <Iconfont name="icon8yiwen-16" size={props.size} />
            </div>
        </Tooltip>
    )
}

Tip.defaultProps = {
    size: 20,
}

export default Tip
